import { render } from "./CroppedFaceImage.vue?vue&type=template&id=6e42ff6e&ts=true"
import script from "./CroppedFaceImage.vue?vue&type=script&lang=ts"
export * from "./CroppedFaceImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__